import React, { useState } from "react";
import { deriveUserId } from "../utils/CryptoHelpers";

export default function SetWipePasswordView({ onBack, currentPassword }) {
  const [input, setInput] = useState("");
  const [confirmInput, setConfirmInput] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSet = async () => {
    setError("");
    setSuccess(false);

    if (!input || !confirmInput) {
      setError("Both fields are required.");
      return;
    }

    if (input !== confirmInput) {
      setError("Passwords do not match.");
      return;
    }

    const wipeId = await deriveUserId(input);
    const userId = await deriveUserId(currentPassword);

    if (wipeId === userId) {
      setError("Wipe password cannot be the same as your login password.");
      return;
    }

    localStorage.setItem(`unlink_${wipeId}_wipe`, userId);
    setSuccess(true);
    setInput("");
    setConfirmInput("");
  };

  return (
    <div style={{ backgroundColor: "#000", color: "#fff", height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          padding: "1rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          onClick={onBack}
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            marginRight: "1rem",
            cursor: "pointer",
          }}
        >
          ←
        </button>
        <h2 style={{ margin: 0 }}>Set Wipe Password</h2>
      </div>

      {/* Content */}
      <div style={{ padding: "2rem", flex: 1 }}>
        <p style={{ marginBottom: "1rem", color: "#ccc" }}>
          If someone logs in using this password, all your local data will be erased.
        </p>

        <input
          type="password"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Enter new wipe password"
          style={{
            width: "100%",
            padding: "0.75rem",
            backgroundColor: "#111",
            color: "#fff",
            border: "1px solid #333",
            borderRadius: "6px",
            marginBottom: "1rem",
          }}
        />

        <input
          type="password"
          value={confirmInput}
          onChange={(e) => setConfirmInput(e.target.value)}
          placeholder="Confirm wipe password"
          style={{
            width: "100%",
            padding: "0.75rem",
            backgroundColor: "#111",
            color: "#fff",
            border: "1px solid #333",
            borderRadius: "6px",
            marginBottom: "1rem",
          }}
        />

        {error && <p style={{ color: "#f66", marginBottom: "1rem" }}>{error}</p>}
        {success && <p style={{ color: "#6f6", marginBottom: "1rem" }}>Wipe password has been saved.</p>}

        <button
          onClick={handleSet}
          style={{
            backgroundColor: "#4e8cff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "0.75rem 1rem",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          Save Wipe Password
        </button>
      </div>
    </div>
  );
}